import { useCategoryActions } from "../actions/categoryActions"
import { useCategoryBuilders } from "../builders/categoryBuilders"
import { useCategoryLoaders } from "../loaders/categoryLoaders"

export const useCategoryService = () => {
    const { buildCategory } = useCategoryBuilders()

    const categoryLoaders = useCategoryLoaders()

    const { saveCategory } = useCategoryActions()

    const archiveCategory = async (categoryId: string) => {
        const { loadCategory } = categoryLoaders()
        const category = await loadCategory(categoryId, true)
        const archivedCategory = buildCategory({
            ...category,
            archived: true
        })
        return saveCategory(archivedCategory)
    }

    return {
        archiveCategory
    }
}
